// extracted by mini-css-extract-plugin
module.exports = {"hh1":"styles_hh1__3N3BF","None":"styles_None__1D6IP"};